import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-reporte-caja',
  templateUrl: './reporte-caja.component.html',
  styleUrls: ['./reporte-caja.component.css']
})
export class ReporteCajaComponent implements OnInit {

  
  url:string;
  urlSafe: SafeResourceUrl;
  
    constructor(public sanitizer: DomSanitizer) { }
  
    ngOnInit() {
      this.url=environment.apiReportes+"cierre_caja_x_fecha.rptdesign&idEmisor="+localStorage.getItem('id');
      this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
   
    }

}

